import React from 'react';

const TeamPage = () => {
    return (
        <div>
            <h1>Our Team</h1>
        </div>
    );
};

export default TeamPage;
